import React from "react";
import { ImageConstants } from "../Utils/Constants/ImageConstants";
function NoData() {
  return (
    <div className="no-image">
      <img src={ImageConstants?.NoData} alt="" />
    </div>
  );
}

export default NoData;
